import i18n from '../../../../../i18n'
import { VehicleLicenseCategory } from '../../../../../model/enums/enums'

export const driverLicense = [
    { value: VehicleLicenseCategory.A, label: i18n.t<string>('A') },
    { value: VehicleLicenseCategory.A2, label: i18n.t<string>('A2') },
    { value: VehicleLicenseCategory.A1, label: i18n.t<string>('A1') },
    { value: VehicleLicenseCategory.B, label: i18n.t<string>('B') },
    { value: VehicleLicenseCategory.BE, label: i18n.t<string>('BE') },
    { value: VehicleLicenseCategory.B1, label: i18n.t<string>('B1') },
    { value: VehicleLicenseCategory.C, label: i18n.t<string>('C') },
    { value: VehicleLicenseCategory.CE, label: i18n.t<string>('CE') },
    { value: VehicleLicenseCategory.C1, label: i18n.t<string>('C1') },
    { value: VehicleLicenseCategory.C1E, label: i18n.t<string>('C1E') },
    { value: VehicleLicenseCategory.D, label: i18n.t<string>('D') },
    { value: VehicleLicenseCategory.DE, label: i18n.t<string>('DE') },
    { value: VehicleLicenseCategory.D1, label: i18n.t<string>('D1') },
    { value: VehicleLicenseCategory.D1E, label: i18n.t<string>('D1E') },
    { value: VehicleLicenseCategory.M, label: i18n.t<string>('M') },
    { value: VehicleLicenseCategory.F, label: i18n.t<string>('F') },
    { value: VehicleLicenseCategory.G, label: i18n.t<string>('G') },
    { value: VehicleLicenseCategory.BPT, label: i18n.t<string>('BPT') },
    { value: VehicleLicenseCategory.CZV, label: i18n.t<string>('CZV') },
    { value: null, label: i18n.t<string>('core.statistic.not_specified') }
]
